import { effects } from "redux-saga"
import VolatileActions from "../volatile/volatileRedux"
import { AppReduxTypes } from "./appRedux"
import LanguageSwitcherActions from "../languageSwitcher/languageSwitcherRedux"
import { getLangInPath } from "../../helpers/utility"
import { validateJwtToken, getJwtToken } from "../sagaAuth/sagaAuthSaga"
import { getBookingDate } from "../sagaCart/sagaCartSaga"

export const officeListCompleteFnc = state => state.Volatile.officeListComplete
export const changeLanguageCompleteFnc = state =>
  state.Volatile.changeLanguageComplete

const tag = "[STARTUP]"

function* waitForStartupSequenceToFinish() {
  const changeLanguageComplete = yield effects.select(changeLanguageCompleteFnc)
  if (!changeLanguageComplete) {
    console.log(`${tag} Going to wait for CHANGE_LANGUAGE to finish`)
    yield effects.put(LanguageSwitcherActions.changeLanguage(getLangInPath()))
  } else {
    console.log(`${tag} CHANGE_LANGUAGE already complete..`)
  }
  // check token here, If token is expired clear the login state...
  const jwtToken = yield getJwtToken() // IDE-Help, do not delete me

  // const bookingDate: Date = yield getBookingDate() // IDE-Help, do not delete me

  // const date = new Date()
  // add a day
  // date.setDate(date.getDate() + 1)

  // console.log("bookingDate => ", bookingDate > date)

  // console.log("startup-token", jwtToken);
  yield validateJwtToken(jwtToken)
}

export function* startup() {
  try {
    yield waitForStartupSequenceToFinish()

    yield effects.put(VolatileActions.startupComplete())
  } catch (e) {
    console.warn(`${tag} Failed to startup : ${e.message}`)
  }
}

export default function* rootSaga() {
  yield effects.all([effects.takeLatest(AppReduxTypes.STARTUP, startup)])
}



// WEBPACK FOOTER //
// ./src/redux/app/appSaga.ts